import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import AnimatedLogo from './AnimatedLogo';
import { useThemeMode } from '../../../../../contexts/ThemeProvider';

const LeftSection = ({ config }: any) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  const leftSectionConfig = config?.login?.leftSection || {};
  const primaryColor = config?.theme?.primary || '#ec027c';
  const secondaryColor = config?.theme?.secondary || '#ec027c';
  const backgroundImageUrl = leftSectionConfig.backgroundImage;
  const blurPx = typeof leftSectionConfig.blurEffect === 'number' ? leftSectionConfig.blurEffect : 18;
  const overlayGradient = isDark
  ? 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.9) 100%)'
  : leftSectionConfig.overlayColor
    ? `linear-gradient(135deg, ${leftSectionConfig.overlayColor})`
    : 'linear-gradient(135deg, rgba(0,36,101,0.6) 0%, rgba(0,36,101,0.6) 100%)';

  return (
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          height: '100vh',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden', 
          background: 'transparent',
          '&::before': backgroundImageUrl
            ? {
                content: '""',
                position: 'absolute',
                inset: 0, 
                backgroundImage: `url("${backgroundImageUrl}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                filter: `blur(${blurPx}px)`,
                transform: 'scale(1.06)', 
                transformOrigin: 'center',
                zIndex: 0
              }
            : {},
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: overlayGradient,
            zIndex: 1,
            pointerEvents: 'none'
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2, 
            textAlign: 'center',
            color: 'white',
            px: 6,
            maxWidth: 600,
            height: '400px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <AnimatedLogo config={config} />

          <Box sx={{ position: 'relative', mb: 6 }}>
            <Typography
              variant="h5"
              color={ !isDark? primaryColor: secondaryColor}
              fontWeight="600"
              mb={1}
              sx={{ opacity: 0.95,  }}
            >
              {leftSectionConfig.content?.mainTitle || 'Welcome to Your Learning Journey'}
            </Typography>
             <Typography
              variant="h5"
              color={ !isDark? primaryColor: secondaryColor}
              fontWeight="600"
              mb={2}
              sx={{ opacity: 0.95,  }}
            >
              {leftSectionConfig.content?.subtitle }
            </Typography>
            <motion.div initial={{ width: 0 }} animate={{ width: 200 }} transition={{ duration: 0.8, delay: 0.3 }}>
              <Box
                sx={{
                  width: { xs: 100, sm: 200, md: 340 },
                  height: 4,
                  background: `linear-gradient(90deg, white 0%, white 40%, ${primaryColor} 70%, transparent 100%)`,
                  borderRadius: 2,
                  opacity: 0.8,
                  mx: 'auto'
                }}
              />
            </motion.div>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default LeftSection;
